import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const Report = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_DISTANCE_REPORTS:
      return {
        ...state,
        distanceReportData: action.value,
      };
    case actions.FETCH_MOBILE_TICKETS_REPORTS:
      return {
        ...state,
        mobileTicketData: action.value,
      };
    case actions.FETCH_DISTANCE_REPORTS_DETAILS:
      return {
        ...state,
        distanceReportDetails: action.value,
      };
    case actions.FETCH_MOBILE_TICKETS_DETAILS:
      return {
        ...state,
        mobileTicketsDetails: action.value,
      };
    case actions.FETCH_MOBILE_SETTLEMENT_DETAILS:
      return {
        ...state,
        mobileSettlementDetails: action.value,
      };
    case actions.DISTANCE_REPORTS_DATA_SYNC:
      return {
        ...state,
        distanceReportDataSync: action.value,
      };
    case actions.FETCH_PASS_REPORTS:
      return {
        ...state,
        passData: action.value,
      };
    case actions.FETCH_PASS_DETAILS:
      return {
        ...state,
        passDetails: action.value,
      };
    case actions.FETCH_PASS_SETTLEMENT_DETAILS:
      return {
        ...state,
        passSettlementDetails: action.value,
      };
    case actions.FETCH_OPERATOR_WISE_REPORT:
      return {
        ...state,
        operatorWiseData: action.value,
      };
    case actions.DISTANCE_UPLOAD_FAILURE:
      return { ...state, distanceUploadSheetError: action.value };
    default:
      return state;
  }
};
export default Report;
